import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbsService {
    breadcrumbChanged = new Subject<any[]>();
    isFloatingChanged = new Subject<boolean>();
    private breadcrumbs = [];
    private isFloating = false;

    constructor() {
    }

    public changeBreadcrumb(value) {
        this.breadcrumbs = value;
        this.breadcrumbChanged.next(this.breadcrumbs);
    }

    public changeFloatingState(value) {
        this.isFloating = value;
        this.isFloatingChanged.next(this.isFloating);
    }
}
